export const BackToTop = ({onClick}) => {
    return (
        <button className="btn btn-upButton fixed bottom-8 right-8" onClick={onClick} type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
                <g transform="translate(-723 -601)">
                    <g transform="translate(764 642) rotate(180)">
                        <g transform="translate(814 561) rotate(180)">
                            <g transform="translate(773 561) rotate(-90)" fill="none" stroke="#000" strokeWidth="2">
                                <circle cx="20.5" cy="20.5" r="20.5" stroke="none" /><circle cx="20.5" cy="20.5" r="19.5" fill="none" />
                            </g>
                            <g transform="translate(801.543 548.189) rotate(180)">
                                <line y2="15.081" transform="translate(8.12)" fill="none" stroke="#000" strokeLinecap="round" strokeWidth="2" />
                                <line x1="8.12" y2="8.12" transform="translate(8.12 7.734)" fill="none" stroke="#000" strokeLinecap="round" strokeWidth="2" />
                                <line x2="8.12" y2="8.12" transform="translate(0 7.734)" fill="none" stroke="#000" strokeLinecap="round" strokeWidth="2" />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </button>
    )
}